// extracted by mini-css-extract-plugin
export default {"choose_documents_body":"ChooseDocumentsModal_choose_documents_body__wydcn","table":"ChooseDocumentsModal_table__-+MwV"};